/** "On a blacked-out day — reschedule": stored work a later plan or line blackout covers. */
import type { TagDeriverCapability } from '@workbuddy/ui/v2/surface.engine';
import { statusToneStyle } from '../../shared/status.tag.tones';

/** The flag's words, shared by the header tag and the Upcoming board's date-cell badge so both say the same thing. */
export const OCCURRENCE_BLACKOUT_LABEL = 'On a blacked-out day — reschedule';

/** Header tag for an occurrence's `onBlackout`; warning, not error, because the work still stands until moved. */
export const occurrenceBlackoutTag: TagDeriverCapability<object> = value => value === true
  ? { label: OCCURRENCE_BLACKOUT_LABEL, ...statusToneStyle('warning') }
  : null;
